import { IndexedDBService } from 'libs/api/src/lib/services/indexed-db.service';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { SharedService } from 'libs/api/src/lib/services/shared.service';
import { GlobalToastService } from 'libs/global-toast/src/lib/services/global-toast.service';
@Injectable({
    providedIn: 'root',
})
export class LogoutGuard  {
    constructor(private _storageService: StorageService, private _router: Router, private _dialog: MatDialog,private indexedDBService: IndexedDBService, private _sharedService: SharedService, private _globalToastService: GlobalToastService) {}
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
        this._sharedService.logout().pipe(
            ).subscribe(data => {
              if(data){
                if (this.indexedDBService['db']) {
                  this.indexedDBService.closeConnection();
                  this.indexedDBService.deleteDB();
                  this.indexedDBService.deleteDataBase();
                }
                this._storageService.clearAll();
                //this.showToast(data['message']);
                this._globalToastService.showToast(data?.message);
                this._dialog.closeAll();
                this._router.navigate(['/login']);
              }
        });
        return true;
    }
}
